<template>
  <div class="flex h-screen">
    <div
      class="bg-center bg-cover border-r-2 flex flex-col items-start justify-end left-pane m-2 p-20 rounded-lg space-y-6 w-172"
    >
      <div class="font-normal lg:text-5xl md:text-4xl text-3xl text-white">{{ $t('title') }}</div>
      <div class="lg:text-2xl max-w-3xl md:text-xl text-gray-400">
        {{ $t('subtext') }}
      </div>
    </div>
    <div class="flex flex-1 items-center justify-center p-2 w-full">
      <slot />
    </div>
    <toast-notifications />
  </div>
</template>

<script>
import ToastNotifications from '~/components/notifications/ToastNotifications';

export default {
  name: 'AuthLayout',

  components: {
    ToastNotifications,
  },

  created() {
    useHead({
      meta: [{ name: 'build-number', content: this.$config.public.buildNumber }],
      titleTemplate: (titleChunk) => {
        return titleChunk ? `${titleChunk} - Crux` : 'Welcome - Crux';
      },
    });
  },
};
</script>

<style scoped>
.left-pane {
  background-image: url('~/assets/img/crux-login-background.svg');
}
</style>

<i18n lang="json">
{
  "en": {
    "subtext": "Crux bridges the gap between outside data sources and the enterprise, helping customers accelerate onboarding, quality, and time-to-value.",
    "title": "Making the world's external data model ready"
  }
}
</i18n>
